import React from 'react'
import { Product } from '../../types/types'
import AddShoppingCartOutlinedIcon from '@mui/icons-material/AddShoppingCartOutlined';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { addCartItem } from '../../redux/reducers/cartReducer';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import Button from '../Button/Button';
import { useNavigate } from 'react-router-dom';
import StarsIcon from '@mui/icons-material/Stars';
import { addFavoriteItem } from '../../redux/reducers/favoriteReducer';
import { editProduct } from '../../redux/reducers/productReducer';

import './ProductCard.scss'

const ProductCard = (props: {product: Product} ) => {
    const navigate = useNavigate()
    const cart = useAppSelector((state)=> state.cartReducer)
    const dispatch = useAppDispatch()
    const addToCart = () => {
        const item = {
            id: props.product.id,
            product: props.product,
            count: 1
        }
        dispatch(addCartItem(item))
    }
    const changeFavorite = () => {
        let favProduct = {...props.product}
        favProduct.isFavorite = !favProduct.isFavorite
        dispatch(editProduct([favProduct]))
        dispatch(addFavoriteItem(props.product))
    }
  return (
    <div className='product-item'>
        <div className="card">
            <div className="content">
                <div className="availability">
                    <p>
                        <CheckCircleIcon sx={{width:16, height: 16}}/>
                        <span>in stock</span>
                    </p>
                </div>
                <div className="image">    
                    <div className="favorite">
                        <button onClick={()=> {
                            changeFavorite()
                        }} className={props.product.isFavorite ? 'fav' : ''}>
                            <StarsIcon/>
                        </button>
                    </div>
                    <img src={props.product.images[0]} onClick={()=> navigate('/products/' + props.product.id)} alt="" />
                </div>
                <p><small>{props.product.id}</small></p>
                <p className='product-title'>{props.product.title.length > 50 ? props.product.title.slice(0, 50) + '...' : props.product.title}</p>
                <p className='bold'>${props.product.price}</p>
                <div className="card-hidden">
                    {cart.find(item => item.id === props.product.id) ?
                    (
                        <Button 
                        variant='disabled'
                        frontIcon={<AddShoppingCartOutlinedIcon sx={{width: 18, height: 18}}/>}
                        >Added To Cart</Button>
                    ) : (
                        <div>
                        <Button 
                        action={() => addToCart()} 
                        variant='outlined'
                        frontIcon={<AddShoppingCartOutlinedIcon sx={{width: 18, height: 18}}/>}
                        >Add To Cart</Button>
                        </div>
                        
                    )}
                </div>
            </div>
        </div>
    </div>
  )
}

export default ProductCard